import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../utils/translations';

export default function BacktestDisclaimer({ compact = false }) {
  const { language } = useLanguage();
  return (
    <div style={{
      marginTop: compact ? '24px' : '48px',
      padding: compact ? '14px 16px' : '18px 20px',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: '8px',
      fontFamily: "'Inter', sans-serif",
      fontSize: compact ? '11px' : '12px',
      color: '#777',
      lineHeight: 1.6,
    }}>
      <strong style={{ color: '#aaa' }}>{t('disclaimer.label', language)}.</strong>{' '}
      {t('disclaimer.body', language)}{' '}
      <Link to="/terms" style={{ color: '#00ffc8', textDecoration: 'none' }}>
        {t('footer.terms', language)}
      </Link>
      .
    </div>
  );
}
